import {Link} from "react-router-dom";
import {i18n} from "translate/i18n";
import React, {useState} from "react";

import {useQuery} from "react-query";

import {getIndicators} from "services/Indicators.service";
import {useUser} from "store/providers/app";
import {ButtonsTable} from "components/Buttons";
import Pagination from "components/Pagination";
import {changeStatus} from "../actions";
import api from "../../../services/api";

export default function IndicatorsList() {

    const [indicators, setIndicators] = useState([])
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const {language} = useUser();

    const statusConfig = (status) => {
        return changeStatus(status)
    }

    const {isFetching} = useQuery(['indicators_list', currentPage],
        () => {
          //  return getIndicators('', currentPage, '', '', language)

            return api.get(`/indicators?paginate=true&page=${currentPage}&minified=true`)

        },
        {
            onSuccess: (res) => {

                console.log('res', res)

                setIndicators(res.data.data)
                setPaginate({
                    from: res.data.meta.from,
                    to: res.data.meta.to,
                    total: res.data.meta.total
                })
            },
            refetchOnWindowFocus: false,
            retry: 2
        })

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    return (
        <div className="card mt-4 border-0 shadow-sm">
            <div className="card-header py-3">
                <Link className="btn btn-outline-success px-5 py-2 float-end bi-plus" to={'/collect/indicator/add'}>
                    Criar nova ficha
                </Link>
            </div>
            <div className="card-body p-0 table-responsive">

                <table className="table align-middle mb-0">
                    <thead className="bg-primary text-uppercase text-sm">
                    <tr>
                        <th className="py-4">Titulo</th>
                        <th className="py-4">Status</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {indicators.map((item, index) =>
                        <tr key={item.id}>
                            <td>{item.titulo}</td>
                            <td>{ statusConfig(item.status).label }</td>
                            <td>
                                <ButtonsTable
                                    trashed={false}
                                    id={item.id}
                                    title={item.titulo}
                                    isFetching={isFetching}
                                />
                            </td>
                        </tr>
                    )}

                    </tbody>
                </table>
            </div>
            <div className="card-footer bg-white border-top-0">
                <Pagination
                    isFetching={isFetching}
                    paginate={paginate}
                    handlePageClick={handlePageClick}
                />
            </div>
        </div>
    )
}
